module.exports = __webpack_public_path__ + "img/image7.0c9e3c19.png";